import React, { useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleClothStock } from '../../../Store/PHPSlice/clothStock';
import PreviewIcon from '@mui/icons-material/Preview';

const TableBody = ({
    serialNumber,
    id,
    clothId,
    clothNm,
    actmtr,
    balmtr,
    sts,
    locNm,
    locId,
    selected,
    handleClick,
    highlightedClothId,
    handleHighlight,
}) => {
    const [color, setColor] = useState(false);
    const isHighlighted = highlightedClothId === id;
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothStkEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Cloth Stock?");

        // If user confirms, proceed with deletion
        // if (isConfirmed) {
        //     dispatch(deleteSingleClothStock(id))
        //         .then(() => {
        //             // Reload the page to show updated results
        //             toast("Cloth Stock Deleted");
        //             window.location.reload();
        //         })
        //         .catch((error) => {
        //             // Handle any errors that occur during the deletion process
        //             console.error("Error deleting Item:", error);
        //             toast.error("Failed to delete Item");
        //         });
        // }
    };

    // const handleViewClick = () => {
    //     window.open(`/ClothStkView/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    // };

    const handleStockGivenMtr = () => {
        handleHighlight(id);
        
        window.open(`/Stock-given-cloths/${clothId}/${locId}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleStockUesdMtr = () => {
        handleHighlight(id);
        window.open(`/Stock-used-cloths/${clothId}/${locId}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    const usedmtr = parseFloat(actmtr) - parseFloat(balmtr);
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell component="th" scope="row"
                    sx={{ p: 1, border: '1px solid #000' }} align='center'>

                    <Typography noWrap>
                        {clothNm}
                    </Typography>

                </TableCell>


                <TableCell component="th" scope="row"
                    sx={{ p: 1, border: '1px solid #000', cursor: 'pointer' }} align='center' onClick={handleStockGivenMtr}
                    className={isHighlighted ? 'onclick-highlight' : 'onclick-highlight-off'}>
                    {actmtr}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', cursor: 'pointer' }} align='center' onClick={handleStockUesdMtr}
                    className={isHighlighted ? 'onclick-highlight' : 'onclick-highlight-off'}>
                    {usedmtr.toFixed(2)}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {balmtr}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {locNm}
                </TableCell>


                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell> */}

            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
